"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64alphabetSwapped = void 0;
const AlphabetStringUppercase_1 = require("./AlphabetStringUppercase");
const AlphabetString_1 = require("./AlphabetString");
const NumbersString_1 = require("./NumbersString");
exports.base64alphabetSwapped = `${AlphabetString_1.alphabetString}${AlphabetStringUppercase_1.alphabetStringUppercase}${NumbersString_1.numbersString}+/=`;
